{
    "NAME": "DirectoryModal",
    "AddDirectoryTitle": "Directory toevoegen",
    "ModifyDirectoryTitle": "Directory wijzigen",
    "TelServerFormLabel": "Telefoon Server",
    "PartitionFormLabel": "Verdeling",
    "TelNumberFormLabel": "Telefoonnummer",
    "DescriptionFormLabel": "Beschrijving",
    "DirectoryAddModify_UnknownOrDeleted": "[Onbekend of Verwijderd]",
    "DirectoryAddModify_ServerErrorTitle": "Validatiefouten",
    "DirectoryAddModify_ValidationWarning": "Zorg ervoor dat alle velden correct zijn ingevuld",
    "DirectoryAddModify_ButtonHelpLabel": "Helpen?",
    "DirectoryAddModify_ButtonSubmitLabel": "Sla",
    "DirectoryAddModify_ButtonCancelLabel": "Annuleren",
    "DirectoryAddModify_PromptMessage": "Weet je zeker dat je dit venster wilt sluiten? Alle gewijzigde configuraties gaan verloren bij het sluiten.",
    "DirectoryAddModify_PromptConfirm": "Ja",
    "DirectoryAddModify_PromptCancel": "Annuleren",
    "TelNumberFormLabel_Validation_Error": "Telefoonnummer is vereist",
    "DescriptionFormLabel_Validation_Error": "Beschrijving is vereist",
    "DirectoryAddModify_TabsDetails": "Details"
}